module.exports = __webpack_public_path__ + "static/media/Рыжкова Елизавета Ивановна Увидеть небо... Вологодская обл.-1.png";